export default __webpack_public_path__ + "static/BroadbandUniversalAccess-e976d91f01459d422e4c87cd5163fbdd.jpg";